import {ajax,getRequestUrl,formatData} from "../request";
export default {
  // 房间水晶



  // 水晶列表
  roomCrystalList(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/roomCrystalList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 水晶等级
  crystalLevelInfo(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/crystalLevelInfo'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 修改水晶礼物接口
  saveCrystalGift(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/saveCrystalGift'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 水晶礼物删除
  deleteRoomCrystal(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/deleteRoomCrystal'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 水晶房间列表
  roomListByPage(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/roomListByPage'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 水晶房间等级保存
  crystalLevelSave(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/crystalLevelSave'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 删除房间
  rc_deleteRoom(data, method) {
    return ajax('post', getRequestUrl('/api/RoomCrystal/deleteRoom'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },


  // 礼物选择
  rc_giftSelectList(data, method) {
    return ajax('post', getRequestUrl('/common/selectList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },
}



// WEBPACK FOOTER //
// ./src/js/https/roomCrystal.js